import iconsPng from '@/assets/img/png/icons';
import ConfirmationModal from '@/components/molecules/ConfirmationModal';
import { PEER_SUPPORT_LEAD_UPGRADE_NOT_ALLOWED } from '@/constants/stringVars';
import { Image, Tooltip, VStack } from '@chakra-ui/react';
import React, { useState } from 'react';

interface Props {
  isPeerSupport: boolean;
  isPeerSupportLead: boolean;
  isRowHovered?: boolean;
  onConfirmPromote: () => void;
  onConfirmDemote: () => void;
}

const PeerSupportLeadOnboardingIconTrigger = ({
  isPeerSupport,
  isPeerSupportLead,
  isRowHovered,
  onConfirmPromote,
  onConfirmDemote,
}: Props) => {
  const [isUpgradeModalOpen, setIsUpgradeModalOpen] = useState(false);
  const [isDowngradeModalOpen, setIsDowngradeModalOpen] = useState(false);

  const onClickIconTrigger = () => {
    if (!isPeerSupport) return;

    if (isPeerSupportLead) {
      setIsDowngradeModalOpen(true);
    } else {
      setIsUpgradeModalOpen(true);
    }
  };

  const opacity = isPeerSupport ? (isPeerSupportLead ? 1 : isRowHovered ? 0.3 : 0) : isRowHovered ? 0.3 : 0;

  return (
    <VStack>
      <Tooltip
        label={`${isPeerSupport ? (isPeerSupportLead ? 'Demote to Peer Support' : 'Promote to Peer Support Lead') : PEER_SUPPORT_LEAD_UPGRADE_NOT_ALLOWED}`}
        color={'text.darkBlue'}
        fontWeight={600}
        background={'white'}
        maxWidth={'140px'}
        borderRadius={'8px'}
        padding={'10px'}
        placement="bottom-start"
        left={5}
      >
        <Image
          alt="peer-support-lead"
          src={iconsPng.peerSupportLead}
          width={4}
          height={5}
          cursor={isPeerSupport ? 'pointer' : 'not-allowed'}
          opacity={opacity}
          _hover={{ opacity: isPeerSupport ? (opacity >= 1 ? opacity - 0.3 : opacity + 0.3) : opacity }}
          onClick={onClickIconTrigger}
        />
      </Tooltip>

      <ConfirmationModal
        title="Promote to Peer Support Lead"
        description={
          'This user will become a Peer Support Lead. Leads are responsible for managing deferred support requests from other peer support members.'
        }
        isOpen={isUpgradeModalOpen}
        onClose={() => setIsUpgradeModalOpen(false)}
        confirmButtonText="Promote"
        onConfirm={() => {
          onConfirmPromote();
          setIsUpgradeModalOpen(false);
        }}
      />

      <ConfirmationModal
        title="Demote from Peer Support Lead"
        description={
          'This user will no longer be a Peer Support Lead and will stop receiving deferred support requests from other members.'
        }
        isOpen={isDowngradeModalOpen}
        onClose={() => setIsDowngradeModalOpen(false)}
        confirmButtonColor="extra.red"
        confirmButtonText="Demote"
        onConfirm={() => {
          onConfirmDemote();
          setIsDowngradeModalOpen(false);
        }}
      />
    </VStack>
  );
};

export default PeerSupportLeadOnboardingIconTrigger;
